<template>
  <div class="form-group row mb-3">
    <label
      v-if="label.length"
      :for="id"
      class="col-sm-4 col-xl-3 col-form-label text-capitalize text-sm-end"
      v-text="label"
    />
    <div :class="{ 'col-sm-8 col-xl-9': label.length }">
      <input
        :type="type"
        v-bind="$attrs"
        :id="id"
        class="form-control"
        :class="{ 'is-invalid': errors }"
        :value="modelValue"
        @input="$emit('update:modelValue', $event.target.value)"
        ref="input"
      />
      <div
        v-if="errors"
        class="invalid-feedback d-block"
        v-html="displayErrors(errors)"
      />
    </div>
  </div>
</template>
 
<script>
export default {
  inheritAttrs: false,
  props: {
    modelValue: {
      type: [Number, String],
      default: "",
    },
    id: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      required: false,
      default: "text",
    },
    label: {
      type: String,
      required: false,
      default: "",
    },
    errors: {
      type: [String, Array],
      required: false,
      default() {
        return "";
      },
    },
  },

  emits: ["update:modelValue"],

  methods: {
    focus() {
      this.$refs.input.focus();
    },
  },

  computed: {
    classInput() {
      return "form-control";
    },
  },
};
</script>

